import { render, staticRenderFns } from "./ShowInputItems.vue?vue&type=template&id=6d6250af&scoped=true&"
import script from "./ShowInputItems.vue?vue&type=script&lang=ts&"
export * from "./ShowInputItems.vue?vue&type=script&lang=ts&"
import style0 from "./ShowInputItems.vue?vue&type=style&index=0&id=6d6250af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6250af",
  null
  
)

export default component.exports